import { breakpoints } from '../../../styles/breakpoints';
import styled from 'styled-components';

export const QuestioMarkWrapper = styled.span`
  display: inline-block;
  margin-left: 0.1rem;

  @media ${breakpoints.md} {
    & svg {
      width: 1.125rem;
      height: 1.875rem;
    }
  }
`;

export const CareerCircle1 = styled.div`
  position: absolute;
  top: 7.813rem;
  right: 18rem;
  width: 16.25rem;
  height: 16.25rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.80) 0%, rgba(100, 255, 227, 0.80) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 14.375rem;
    height: 14.375rem;
    left: 4.5rem;
    right: unset;
    top: 6.375rem;
  }
`;

export const CareerCircle2 = styled.div`
  position: absolute;
  bottom: -3.5rem;
  right: 7.5rem;
  width: 14.375rem;
  height: 14.375rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0.75) 0%, rgba(32, 22, 88, 0.75) 100%, rgba(0, 0, 0, 0.75) 100%);
  filter: blur(7.813rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 12.5rem;
    height: 12.5rem;
    right: -3.5rem;
    bottom: 7.313rem;
  }
`;

export const ContactCircle1 = styled.div`
  position: absolute;
  top: 7.813rem;
  right: 18rem;
  width: 16.25rem;
  height: 16.25rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.80) 0%, rgba(100, 255, 227, 0.80) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 7.5rem;
    height: 7.5rem;
    right: -3rem;
    top: unset;
    bottom: 0;
    background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.60) 0%, rgba(100, 255, 227, 0.60) 100%);
    filter: blur(5.688rem);
  }
`;

export const ContactCircle2 = styled.div`
  position: absolute;
  right: 7.5rem;
  bottom: -7.188rem;
  width: 14.375rem;
  height: 14.375rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0.75) 0%, rgba(32, 22, 88, 0.75) 100%, rgba(0, 0, 0, 0.75) 100%);
  filter: blur(7.813rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 10.625rem;
    height: 10.625rem;
    right: 2.813rem;
    bottom: 2.5rem;
    background: radial-gradient(50% 50% at 50% 50%, rgba(129, 108, 255, 0.40) 0%, rgba(129, 108, 255, 0.40) 100%);
    filter: blur(4.688rem);
  }
`;

export const WorkCircle1 = styled.div`
  position: absolute;
  right: 8.438rem;
  bottom: -2.813rem;
  width: 12.5rem;
  height: 12.5rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.80) 0%, rgba(100, 255, 227, 0.80) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 6.25rem;
    height: 6.25rem;
    right: -1.563rem;
    top: 5rem;
    bottom: unset;
    background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.80) 0%, rgba(100, 255, 227, 0.80) 100%);
    filter: blur(4.688rem);
  }
`;

export const ProcessCircle1 = styled.div`
  position: absolute;
  top: 5rem;
  left: 5rem;
  width: 17.5rem;
  height: 17.5rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(129, 108, 255, 0.60) 0%, rgba(129, 108, 255, 0.60) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 10.625rem;
    height: 10.625rem;
    right: 12.75rem;
    left: unset;
    bottom: unset;
    top: 4rem;
    background: radial-gradient(50% 50% at 50% 50%, rgba(129, 108, 255, 0.40) 0%, rgba(129, 108, 255, 0.40) 100%);
    filter: blur(4.688rem);
  }
`;

export const ProcessCircle2 = styled.div`
  position: absolute;
  bottom: -5rem;
  right: 6rem;
  width: 17.5rem;
  height: 17.5rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.50) 0%, rgba(100, 255, 227, 0.50) 100%);
  filter: blur(9.375rem);
  z-index: 2;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 7.5rem;
    height: 7.5rem;
    right: -2.875rem;
    left: unset;
    bottom: unset;
    top: 15rem;
    background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.60) 0%, rgba(100, 255, 227, 0.60) 100%);
    filter: blur(5.625rem);
  }
`;